import type { TreatmentPlan } from "./treatmentPlan/treatmentPlanData";
import type { TreatmentPlanDates } from "./pharmacyFirst/utils/calculateTreatmentPlanDates";
import type { AHTPlannedAppointment } from "./pharmacyFirst/utils/generateAHTAppointments";

export type { TreatmentPlanDates };

export type AHTEpisodeOrigin = "initialSupply" | "transferIn";

export type AHTDrugId =
  | "tirzepatide"
  | "semaglutide"
  | "liraglutide"
  | "mysimba"
  | "orlistat";

export type QuestionnaireStatus =
  | "not_sent"
  | "sent"
  | "returned"
  | "overdue";

export interface AHTSupplyEvent {
  id: string;
  consultationId: string;
  supplyDate: string;
  drugId: AHTDrugId;
  dose: string;
  batchNumber: string;
  expiryDate: string;
  brandName: string | null;
  bpPulse?: {
    systolic: number;
    diastolic: number;
    pulse: number;
  };
  weightKg: number;
  waistCircumferenceCm?: number;
  weekNumber: number;
  wasInTitrationPhase: boolean;
  pharmacistName: string;
  pharmacistRegistrationNumber: string;
  clinicalRationale: string;
  prescriberDecision: "continue" | "escalate" | "contactPatient";
}

export interface AHTWeightTreatmentPlan extends TreatmentPlan {
  episodeOrigin: AHTEpisodeOrigin;
  resolvedDrugId: AHTDrugId;
  pgdIdAtInitiation: string;
  pgdVersionAtInitiation: string;
  parentConsultationId: string;
  baselineWeightKg: number;
  baselineWaistCircumferenceCm: number | null;
  baselineBmi: number;
  currentDose: string;
  currentWeek: number;
  maintenanceEpisodeCount: number;
  initialSupplyDate: string;
  nextQuestionnaireDueDate: string;
  nextSupplyDueDate: string;
  nextDrugSpecificReviewDueDate: string;
  drugSpecificReviewLabel: string;
  nextSectionBReviewDueDate: string;
  questionnaireStatus: QuestionnaireStatus;
  questionnaireSentAt: string | null;
  questionnaireReturnedAt: string | null;
  plannedAppointmentDetails: AHTPlannedAppointment[];
  supplyHistory: AHTSupplyEvent[];
}

export function calculateWeightLossPercent(
  baselineWeightKg: number,
  currentWeightKg: number,
): number | null {
  if (baselineWeightKg <= 0) return null;
  return ((baselineWeightKg - currentWeightKg) / baselineWeightKg) * 100;
}

export function calculateWeightLossKg(
  baselineWeightKg: number,
  currentWeightKg: number,
): number | null {
  if (baselineWeightKg <= 0) return null;
  return baselineWeightKg - currentWeightKg;
}
